import InvoiceType from "$routes/patient/[:patientId]/_lib/invoices/invoice-type";
import { Box, Divider, makeStyles } from "@material-ui/core";
import Footer from "../PrintableInvoice/Footer";
import Header from "./LaserReceiptPrint/Header";
import LineItems from "./LaserReceiptPrint/LineItems";
import Paid from "./LaserReceiptPrint/Paid";
import PatientDetails from "./LaserReceiptPrint/PatientDetails";
import TransactionLines from "./LaserReceiptPrint/TransactionLines";

const useStyles = makeStyles((theme) => ({
  containerWrapper: {
    display: "none",
  },
  printWrapper: {
    margin: "5mm",
  },
  box: {
    border: `1px solid ${theme.palette.grey[600]}`,
    padding: theme.spacing(2),
  },
  itemPriceDivider: {
    backgroundColor: theme.palette.text.primary,
    border: `2px solid ${theme.palette.text.primary}`,
    height: 0,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    width: "100%",
  },
  invoiceNumber: {
    fontFamily: theme.typography.fontBold,
  },
}));

const PatientLaserReceipt = ({ invoice }) => {
  const classes = useStyles();
  const { invoiceNumber } = invoice;
  const enabledLineItems = invoice.lineItems.filter(
    (lineItem) => !lineItem.disabled,
  );
  return (
    <div id="printWrapper" className={classes.printWrapper}>
      <div style={{ pageBreakBefore: "always" }}>
        <Box p={[2, 0]} className={classes.box}>
          <Header invoice={invoice} />
          <PatientDetails patientDetails={invoice.patient} />
          <Box mb={2} className={classes.invoiceNumber}>
            {invoiceNumber}
          </Box>
          <LineItems lineItems={enabledLineItems} />
          <Divider className={classes.itemPriceDivider} />
          <Paid invoice={invoice} />
          <TransactionLines invoice={invoice} />
          <Box display="flex" flexDirection="column" alignItems="center">
            <Footer />
          </Box>
        </Box>
      </div>
    </div>
  );
};
PatientLaserReceipt.propTypes = {
  invoice: InvoiceType.isRequired,
};

export default PatientLaserReceipt;
